/**
 * Faint drafting grid (fills its relative parent): minor lines every 8px, major every 40px.
 * `fade` masks it to an ellipse at the top so it dissolves into the page.
 */
export default function BlueprintGrid({ fade = false }: { fade?: boolean }) {
  const mask = 'radial-gradient(ellipse 70% 60% at 50% 0%, #000 35%, transparent 80%)'
  return (
    <div
      aria-hidden="true"
      className="pointer-events-none absolute inset-0"
      style={{
        backgroundImage: [
          'linear-gradient(rgba(6,182,212,0.08) 1px, transparent 1px)',
          'linear-gradient(90deg, rgba(6,182,212,0.08) 1px, transparent 1px)',
          'linear-gradient(rgba(6,182,212,0.04) 1px, transparent 1px)',
          'linear-gradient(90deg, rgba(6,182,212,0.04) 1px, transparent 1px)',
        ].join(','),
        backgroundSize: '40px 40px, 40px 40px, 8px 8px, 8px 8px',
        ...(fade && { maskImage: mask, WebkitMaskImage: mask }),
      }}
    />
  )
}
